/* @flow */
import { compact, formatDollars, formatWholeDollars } from '../../utils';
import type { FareEstimate } from '../../data/FareEstimates';
import Products from '../../data/Products';

const getFareEstimatesByLocationIdsEntities = (state: Object) =>
  state.entities.fareEstimatesByLocationIds;
const getFareEstimatesByIdEntities = (state: Object) => state.entities.fareEstimatesById;

export function getNewFareEstimate(state: Object) {
  return state.fareEstimates.newFareEstimate;
}

export function getFareEstimatesByLocationIds(
  state: Object,
  originId: string,
  destinationId: string,
  useCase?: string
): ?(FareEstimate[]) {
  let fareEstimates = getFareEstimatesByLocationIdsEntities(state);
  let key = compact([originId, destinationId, useCase]).join(':');
  if (!fareEstimates) return null;
  if (!fareEstimates[key]) return null;
  // Skip estimates for products we don't recognize
  return fareEstimates[key].filter(estimate => Products[estimate.product.slug] !== undefined);
}

export function getFareEstimateByLocationIdsAndProduct(
  state: Object,
  originId: string,
  destinationId: string,
  product: string,
  useCase?: string
) {
  const fareEstimates = getFareEstimatesByLocationIds(state, originId, destinationId, useCase);
  if (!fareEstimates) return null;
  return fareEstimates.find(estimate => estimate.product.slug === product);
}

export function getFareEstimateById(state: Object, fareEstimateId: string) {
  let fareEstimates = getFareEstimatesByIdEntities(state);
  if (!fareEstimates) return null;
  return fareEstimates[fareEstimateId];
}

export function getDisplaySummary(fareEstimate: Object, promoCode?: Object) {
  const {
    low_fare: { travel },
    fare_structure,
  } = fareEstimate;
  const travelCostCents = Object.values(travel).reduce((memo, { fare }) => {
    return memo + fare;
  }, 0);
  const baseCents = fare_structure.base;
  const perMinLabor = fare_structure.per_minute_labor;
  const title = perMinLabor === 0 ? 'Final price:' : 'Price:';
  let baseAndTravelCents = travelCostCents + baseCents;
  let estimate;

  if (promoCode) {
    if (promoCode.category === 'free_lugg') {
      estimate = 'FREE';
    } else {
      baseAndTravelCents = Math.max(baseAndTravelCents - promoCode.amount, 0);
    }
  }
  if (!estimate) {
    estimate = formatWholeDollars(baseAndTravelCents);
    if (perMinLabor > 0) {
      estimate += ` + ${formatDollars(perMinLabor)} per labor min`;
    }
  }

  return {
    title,
    estimate,
    fixedPrice: perMinLabor === 0,
  };
}



// WEBPACK FOOTER //
// ./src/redux/fare-estimates/selectors.js